import { Grid } from '@mui/material';
import { RoutalButton, RoutalPalette } from '@nx-smartmonkey/ui';
import { useIntl } from 'react-intl';

import { useNavigate } from 'react-router';
import Logo from '../assets/img/logo.png';
import * as routing from '../constants/Routing';

export const Header = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <Grid
      container
      style={{ height: `64px`, backgroundColor: RoutalPalette.primary40n, padding: `0 12px` }}
      wrap="nowrap"
    >
      <Grid container alignContent="center" onClick={() => navigate(routing.ROOT)} style={{ cursor: `pointer` }}>
        <img src={Logo} height="36px" alt="logo" />
      </Grid>
      <Grid container justifyContent="flex-end" alignContent="center">
        <Grid item>
          <RoutalButton style={{ textTransform: `none` }} variant="text" onClick={() => navigate(routing.APIv2)}>
            {intl.formatMessage({ id: `developers.heading.button` })}
          </RoutalButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
